var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltipContent,
    offset: 0,
  }),expression:"{\n    content: tooltipContent,\n    offset: 0,\n  }"}],staticClass:"feature-update-tooltip-wrapper"})
}
var staticRenderFns = []

export { render, staticRenderFns }